import React, { useState, useEffect,useCallback } from 'react';
import PageHeader from '../../components/PageHeader';
import AppHeader from '../../components/AppHeader';
import AppSidebar from '../../components/AppSidebar';
import CustomersService from "../../services/CustomersService";
import { toast, ToastContainer } from 'react-toastify';
import CommonTable from '../../components/CommonTable';
import Pagination from '../../components/Pagination';
import Filters from '../../components/Filters';
import UseDebounce from '../../hooks/UseDebounce';
import { PageLimit } from '../../utils/ConstantUtils';
import { DebounceDelay } from '../../utils/ConstantUtils';
import  Import  from '../../modals/Import';

const Customer = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const pageLimit = PageLimit;
  const [itemsPerPage, setPageLimit] = useState(pageLimit);
  const offset = (currentPage - 1) * itemsPerPage;
  const [appliedFilters, setAppliedFilters] = useState({});
  const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);
  const [showImportModal, setShowImportModal] = useState(false);

  const columns = [
    { Header: '', accessor: ''},
    { Header: '#', accessor: 'id'},
    { Header: 'Company', accessor: 'company'},
    { Header: 'GST Number', accessor: 'gst_no'},
    { Header: 'Phone No', accessor: 'phone'},
    { Header: 'Official Email', accessor: 'official_email'},
    { Header: 'Website', accessor: 'website'},
    { Header: 'Currency', accessor: 'currency'},
    { Header: 'City', accessor: 'city'},
    { Header: 'State', accessor: 'state'},
    { Header: 'Country', accessor: 'country'},
    { Header: 'Zipcode', accessor: 'zipcode'},
    { Header: 'Address', accessor: 'address'},
    { Header: 'Industry Type', accessor: 'industry_type'},
    { Header: 'Employee Count', accessor: 'employee_count'},
    { Header: 'Status', accessor: 'status'},
    { Header: 'Created By', accessor: 'createdBy'},

  ];
  const [selectedRows, setSelectedRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await CustomersService.getAll({
        page: currentPage,
        limit: itemsPerPage,
        search: debouncedSearchTerm,
        offset: offset,
        filters: appliedFilters,
      });
      if (response.status === 200 && response.data.success) {
        setRows(response?.data?.data?.customers);
        setTotalPages(response?.data?.data?.totalPages);
        setCurrentPage(response?.data?.data?.currentPage);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, debouncedSearchTerm, offset, appliedFilters])

  useEffect(() => {
    fetchData();
  }, [appliedFilters, fetchData]);


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setPageLimit(e.target.value);
  };

  const handleFilterSubmit = (newFilters) => {
    setAppliedFilters(newFilters);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'active':
        return 'badge bg-success'; 
      case 'inactive':
        return 'badge bg-danger'; 
      default:
        return 'badge bg-dark'; 
    }
  };

  const filterFields = [
    { name: 'company', placeholder: 'Company Name' , Dropdown : "yes" },
    { name: 'gst_no', placeholder: 'GST No' , Dropdown : "yes" },
    { name: 'phone', placeholder: 'Phone No' , Dropdown : "yes" },
    { name: 'official_email', placeholder: 'Official Email' , Dropdown : "yes" },
    { name: 'website', placeholder: 'Website' , Dropdown : "no" },
    { name: 'currency', placeholder: 'Currency' , Dropdown : "yes" },
    { name: 'city', placeholder: 'City' , Dropdown : "yes" },
    { name: 'industry_type', placeholder: 'Industry Type' , Dropdown : "yes" },
    { name: 'created_by', placeholder: 'Created By' , Dropdown : "yes" },
  ];
  const handleButtonClick = () => {
    setShowImportModal(true); // Show the import modal
  }
  const handleCloseImportModal = () => {
    setShowImportModal(false); // Close the import modal
  };

  const instructions =[  "Your file data should be in the format below. The first line of your file should be the column headers as in the table example. Also make sure that your file is UTF-8 to avoid unnecessary encoding problems.",
    "If the column you are trying to import is date, make sure that it is formatted as Y-m-d (e.g., 2024-09-05).",
    "Based on your data unique validation configured options, the lead won't be imported if: Lead company already exists. If you still want to import all data, uncheck all unique validation fields."
  ];

  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <PageHeader title="Customers" button_label="Create" link_to="create" className="btn btn-sm btn-primary me-2"  button_label1="Import" buttonAttributes1={{ onClick: handleButtonClick }} className1="btn btn-sm btn-secondary" />
              <div className="tab-content">
                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                  <div className="card">
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <form>
                            <div className="input-group input-group-flush input-group-merge input-group-reverse">
                              <input
                                className="form-control list-search"
                                type="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={handleSearchChange}
                              />
                              <span className="input-group-text">
                                <i className="fe fe-search" />
                              </span>
                            </div>
                          </form>
                        </div>
                        <div className="col-auto me-n3">
                          <form>
                            <select
                              className="form-select form-select-sm form-control-flush"
                              value={itemsPerPage}
                              onChange={handleItemsPerPageChange}
                            >
                              <option value="20">20 per page</option>
                              <option value="40">40 per page</option>
                              <option value="60">60 per page</option>
                              <option value="100">100 per page</option>
                            </select>
                          </form>
                        </div>
                        <div className="col-auto">
                          {/* Use the Filters component here */}
                          <Filters filterFields={filterFields} onApplyFilters={handleFilterSubmit} getFilterService={CustomersService.getCustomersFilter} />
                        </div>
                      </div>
                    </div>

                    {/* Common Table component*/}
                    <CommonTable
                      loading={loading}
                      rows={rows}
                      columns={columns}
                      selectedRows={selectedRows}
                      setSelectedRows={setSelectedRows}
                      basePath="customers"
                      showLimitedOptions={false}
                      offset={offset}
                      getStatusBadgeClass = {getStatusBadgeClass}
                      showCheckboxes = {false}

                    />
                    <ToastContainer />

                    {/* Pagination Component */}
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      setCurrentPage={setCurrentPage}
                    />
                    {/* Import Modal */}
                    <Import
                      show={showImportModal}
                      handleClose={handleCloseImportModal}
                      refreshData={fetchData}
                      modalTitle="Import Customers"
                      modalBody="Upload your file here. Make sure that your file is in the correct format."
                      pageHeaderTitle="Import Data"
                      service={CustomersService}
                      columns={columns}
                      instructions={instructions}
                      sampleFileUrl="/assets/sample files/customer_sample_import_file.xlsx"
                      sampleFileName="customer_sample_import_file.xlsx"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Customer;
